import script from "./Login.vue?vue&type=script&lang=ts&setup=true"
export * from "./Login.vue?vue&type=script&lang=ts&setup=true"

import "./Login.vue?vue&type=style&index=0&id=13b3e7cb&lang=less&scoped=true"

import exportComponent from "D:\\鹿小岚\\crm\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-13b3e7cb"]])

export default __exports__